import React, {useState} from "react";
import Card from "./Card/Card.jsx";
import Carousel from 'react-bootstrap/Carousel';
import "./testimonials.scss";

export default function Testimonials(){

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    selectedIndex >= 2 ? setIndex(0) : setIndex(selectedIndex);
  };

  const string1="My Experience during IELTS classes held by Leverage.edu was exceptional.I joined in September. The team was very co-operative and often communicated with the students. I felt really satisfied with the Leverage.edu course.";
  const string2="I am extremely grateful to the entire Leverage IELTS team, who got me well versed with the exam format and helped me achieve an 8.5 overall IELTS score in short notice. I felt extremely lucky and satisfied to come across Leverage.edu.";


  return(
    <div className="testimonials" id="testimonials">
     <div className="Headerwithbtn">
      <div className="test-heading">
      Testimonials
    </div>
    <div className="sliderbuttons">
    <button className="prevBtn" id="prevBtn"  onClick={() =>
            index === 0
              ? setIndex(2)
              : setIndex(index - 1)
          }>&lt;</button>
    <button className="nextBtn" id="nextBtn" onClick={() =>
            index === 2
              ? setIndex(0)
              : setIndex(index + 1)
          }>&gt;</button>
    </div>
    </div>
       <div className="test-con">
       <Carousel className="contentBox" activeIndex={index} onSelect={handleSelect}>
       <Carousel.Item >
       <div className="slide">
       <Card canName="anisha" fullname="Anusha Ohri"string={string1} band="8.0" />
       <Card canName="krishna" fullname="Krishna" string={string2} band="8.5" />
        </div>
        </Carousel.Item>
        <Carousel.Item >
     <div className="slide">
     <Card canName="anisha" fullname="Anusha Ohri" string={string1} band="8.0" />
     <Card canName="krishna" fullname="Krishna" string={string2} band="8.5" />
         </div>
         </Carousel.Item>
         <Carousel.Item >
         <div className="slide">
         <Card canName="anisha" fullname="Anusha Ohri" string={string1} band="8.0" />
         <Card canName="krishna" fullname="Krishna" string={string2} band="8.5" />
         </div>
          </Carousel.Item>
        </Carousel>
       </div>
    </div>
  )
}
